import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import Clipboard from 'clipboard';
import { notifySuccess } from '../Notification';
import { useTranslate } from '../util';
import { ButtonBabyPrimary, ButtonBabySecondary, ButtonPrimary, ButtonSecondary } from './Button';
export var ButtonClipboardPrimary = createClipboardButton(ButtonPrimary);
export var ButtonClipboardSecondary = createClipboardButton(ButtonSecondary);
export var ButtonClipboardBabyPrimary = createClipboardButton(ButtonBabyPrimary);
export var ButtonClipboardBabySecondary = createClipboardButton(ButtonBabySecondary);
function createClipboardButton(Button) {
  return function ClipboardButton(props) {
    var button = React.useRef();
    var t = useTranslate();
    var toastMessage = props.toastMessage,
      children = props.children,
      targetId = props.targetId,
      buttonProps = _objectWithoutProperties(props, ["toastMessage", "children", "targetId"]);
    React.useEffect(function () {
      var clipboardInstance = new Clipboard(button.current);
      clipboardInstance.on('success', function (e) {
        e.clearSelection();
        if (toastMessage !== null) {
          notifySuccess(toastMessage || t('citrix-ui:copy_success'));
        }
      });
      return function cleanup() {
        clipboardInstance.destroy();
      };
    }, [t, toastMessage]);
    return /*#__PURE__*/React.createElement(Button, _extends({
      type: "button"
    }, buttonProps, {
      "data-clipboard-target": "#".concat(targetId),
      buttonRef: function buttonRef(element) {
        return button.current = element;
      }
    }), children);
  };
}